<template>
  <q-card square class="sticky-header-card">
    <div class="center-sticky-header">
      <mileage-sub-menu class="sticky-margin"></mileage-sub-menu>
      <div class="sticky-sub-menu">
        <div class="filter-info">
          Filters:
          <q-badge
            v-if="
              !selectedVehicle ||
                !selectedVehicle.brand ||
                !selectedVehicle.brand.name
            "
            color="negative"
            >NONE</q-badge
          >
          <q-badge
            style="margin-right:5px"
            outline
            color="positive"
            v-if="
              selectedVehicle &&
                selectedVehicle.brand &&
                selectedVehicle.brand.name
            "
            >Vehicle :
            {{
              selectedVehicle &&
              selectedVehicle.brand &&
              selectedVehicle.brand.name
                ? `${selectedVehicle.brand.name}#${selectedVehicle.vin}`
                : ""
            }}</q-badge
          >
        </div>
        <div class="sticky-add">
          <q-btn
            round
            @click="$store.commit('millage/SET_ADD', true)"
            color="red"
            size="xs"
          >
            <q-icon name="fas fa-plus" style="margin-top:3px"></q-icon>
          </q-btn>
        </div>
        <q-icon
          color="grey-7"
          @click="subMenu = true"
          name="fas fa-caret-down"
          class="cursor-pointer"
          size="25px"
        ></q-icon>

        <q-dialog
          v-model="subMenu"
          persistent
          transition-show="scale"
          transition-hide="scale"
        >
          <q-card style="width: 300px">
            <div class="bg-primary text-white sub-menu-title">
              <div class="text-h6">Filters</div>

              <q-icon
                @click="subMenu = false"
                name="fas fa-times"
                class="cursor-pointer"
              ></q-icon>
            </div>
            <mileage-sub-menu class="sub-menu-filters">
              <template v-slot:activator>
                <q-btn
                  label="Close"
                  size="md"
                  @click="subMenu = false"
                  color="negative"
                  style="margin-top:5px;width:100%"
                ></q-btn>
              </template>
            </mileage-sub-menu>
          </q-card>
        </q-dialog>
      </div>
    </div>
  </q-card>
</template>

<script>
import MileageSubMenu from "./MileageSubMenu";
import axios from "../axios/index";
export default {
  components: {
    MileageSubMenu,
  },
  data() {
    return {
      subMenu: false,
    };
  },
  async mounted() {
    if (this.$store.state.millage.vehicles.length === 0) {
      const params = { page: 1, per: 1000 };
      const { data } = await axios.get("vehicles", { params });
      this.vehicles = data.data.items;
    }
    const vehicles = this.$store.state.millage.vehicles;
    const selected = this.$store.state.millage.selectedVehicle;
    if (
      vehicles.length > 0 &&
      (!selected || !selected.brand || !selected.brand.id)
    )
      this.selectedVehicle = vehicles[0];
  },
  computed: {
    selectedVehicle: {
      get() {
        return this.$store.state.millage.selectedVehicle;
      },
      set(val) {
        this.$store.commit("millage/SET_SELECTED_VEHICLE", val);
      },
    },
    selectedMillage: {
      get() {
        return this.$store.state.millage.selectedMillage;
      },
      set(val) {
        this.$store.commit("millage/SET_SELECTED_MILLAGE", val);
      },
    },
    vehicles: {
      get() {
        return this.$store.state.millage.vehicles;
      },
      set(val) {
        this.$store.commit("millage/SET_VEHICLES", val);
      },
    },
  },
};
</script>

<style lang="scss"></style>
